import type { ReactNode } from "react";

interface Props {
  icon: string;
  title: string;
  subtitle?: string;
  accent?: "primary" | "accent" | "secondary";
  action?: ReactNode;
}

const barMap = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

const iconMap = {
  primary: "text-primary-500",
  accent: "text-accent-500",
  secondary: "text-secondary-500",
};

export default function SectionHeading({ icon, title, subtitle, accent = "primary", action }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4 md:mb-6">
      <div className="flex items-center gap-3">
        <span className={`${barMap[accent]} w-1.5 h-7 rounded-full`} />
        <div>
          <h4 className="flex items-center gap-2 text-lg md:text-xl font-bold text-foreground-950">
            <i className={`${icon} ${iconMap[accent]}`} />
            {title}
          </h4>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-1">{subtitle}</p>}
        </div>
      </div>
      {action}
    </div>
  );
}